import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLoadingAxiosState)?_c('div',{staticClass:"__loading"},[_c(VProgressLinear,{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }